import { captureException } from '@sentry/nextjs';

import { User } from 'modules/users/types';
import httpClient from 'src/http-client';

export const loadProBySlug = async ({ slug }: { slug: string }): Promise<User | undefined> => {
  try {
    const { data } = await httpClient.get<User>(`/pros/get-by-slug/${slug}`);
    return data;
  } catch (error) {
    captureException(error);
  }
  return;
};
